var map = {
	"./Frame 7.png": "b120",
	"./bordergame_play_icon.png": "5cf1",
	"./chess-searchbg.jpg": "ac1e",
	"./chess-searchbg1.jpg": "e581",
	"./chess-searchbg2.jpg": "0c21",
	"./chess-searchbg3.jpg": "3a22",
	"./chess-searchbg4.jpg": "4145",
	"./chess-searchbg5.jpg": "c5da",
	"./chess-searchbg6.jpg": "93ac",
	"./funwLogo1.png": "e038",
	"./gtgLogo.png": "fb64",
	"./gtgLogo1.png": "6917",
	"./html5_img.png": "e74f",
	"./icons.png": "24bc",
	"./jk_bg.png": "269a",
	"./jk_close.png": "493c",
	"./jk_icon.png": "809b",
	"./jk_icon_active.png": "47f0",
	"./jk_tab.png": "d43f",
	"./jk_tab_active.png": "428a",
	"./jramjsLogo.png": "1e90",
	"./jramjsLogo1.png": "ced0",
	"./jrwnsrLogo.png": "07fc",
	"./jrwnsrLogo1.png": "0bec",
	"./jrylLogo.png": "1e1c",
	"./login-close.png": "a1e8",
	"./login-close2.png": "2f14",
	"./lottery-bg.png": "6007",
	"./nInfoMsg.png": "d3fd",
	"./nInfoMsgIsEmpty.png": "8fed",
	"./nInfoMsgUnRead.png": "3f7d",
	"./nInfoNotice.png": "2c4c",
	"./nInfoNoticeIsEmpty.png": "850e",
	"./nInfoNoticeUnRead.png": "0188",
	"./regChecked.png": "0a05",
	"./regUnCheck.png": "fd1c",
	"./searchlost.png": "d4b6",
	"./slots_list_logo.png": "94db",
	"./tycaLogo.png": "9dc4",
	"./vi/Backwater.png": "1bf5",
	"./vi/BackwaterA.png": "b6ea",
	"./vi/deposit.png": "f996",
	"./vi/depositA.png": "bf3e",
	"./wyylLogo.png": "96fc",
	"./xiaocaoLogo.png": "91f9",
	"./zh_CN/Backwater.png": "ebea",
	"./zh_CN/BackwaterA.png": "e7dc",
	"./zh_CN/deposit.png": "4019",
	"./zh_CN/depositA.png": "32c3"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "2217f";